import {PipeTransform, Pipe} from '@angular/core';

@Pipe({ name: 'highlight', standalone: false })
export class HighlightPipe implements PipeTransform {
    transform(text: string, search: string): string {
        let pattern = search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
        pattern = pattern.split(' ').filter((t: any) => {
            return t.length > 0;
        }).join('|');
        const regex = new RegExp(pattern, 'gi');

        return search ? this.escapeHtml(text.replace(regex, (match) => `<span class="highlight">${match}</span>`)) : text;
    }

    escapeHtml(s: string) {
        return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    }
}
